import React from "react";
import { FiDownload } from "react-icons/fi";
import { CiSearch } from "react-icons/ci";
import { IoSearch } from "react-icons/io5";

const Statistics = ({ tokens }) => {
  console.log(tokens, "tokens");
  return (
    <div className="userInfo">
      <div className="  mt-8">
        <h2 className=" font-semibold mb-4 text-2xl text-black text-center md:text-left dark:text-white">
          Remaining Tokens
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-center">
          {/* Saved Recipes card */}
          {/* <div className="flex flex-col items-center justify-center gap-2 mb-4 h-[140px]  rounded-xl p-4 bg-[#FFF0F0]  dark:bg-orange-300">
            <span className="text-2xl text-[#ED2024]">
              <FiDownload />
            </span>
            <span className="text-2xl font-bold text-black">
              {tokens?.recipeTokens || 0}
            </span>
            <span className="text-black text-lg text-semibold">
              Remaining Download Tokens
            </span>
          </div> */}

          {/* Created Recipes */}
          <div className="flex flex-col items-center justify-center gap-2 mb-4 rounded-xl p-4 h-[140px]  bg-[#FFF0F0]   dark:bg-orange-300">
            <span className="text-2xl text-[#ED2024] font-bold">
              <IoSearch />
            </span>
            <span className="text-2xl font-bold text-black">
              {tokens?.recipeTokens || 0}
            </span>
            <span className="text-black text-lg text-semibold">
              Remaining Recipe Tokens
            </span>
          </div>
          {/* Shared Recipes */}
          <div className="flex flex-col items-center justify-center gap-2 mb-4 rounded-xl p-4 h-[140px]  bg-[#FFF0F0]  dark:bg-orange-300">
            <span className="text-2xl text-[#ED2024] font-bold">
              <IoSearch />
            </span>
            <span className="text-2xl font-bold text-black">
              {tokens?.dishTokens || 0}
            </span>
            <span className="text-black text-lg text-semibold">
              Remaining Search Tokens
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Statistics;
